module.exports = __webpack_public_path__ + "static/media/5613.aca9706b.jpg";